import { Component, EventEmitter, Output } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { Store } from '@ngxs/store';
import { AuthService } from '../../../../services/auth.service';
import { ButtonComponent } from '../../button/button.component';

@Component({
  selector: 'app-confirmation-modal',
  standalone: true,
  imports: [TranslateModule, ButtonComponent],
  templateUrl: './confirmation-modal.component.html',
  styleUrl: './confirmation-modal.component.scss'
})
export class ConfirmationModalComponent {

  @Output() confirm: EventEmitter<Boolean> = new EventEmitter();

  constructor(public modal: NgbModal, private authService: AuthService, private store: Store,
    public activeModal: NgbActiveModal
   ) { }

  confirmation() {
    this.confirm.emit(true)
    this.activeModal.close('Confirmed'); // Closes the modal and sends data
  }

  dismiss() {
    this.activeModal.dismiss('Cancelled'); // Dismisses the modal
  }

}
